<h4 mat-dialog-title>Редактирование вида работ</h4>
<app-close-button [formGroup]="workForm" [dialogRef]="dialogRef"/>
<mat-dialog-content>
    <app-loader [isLoading]="loading()"/>
    <form class="flex-column" [formGroup]="workForm" (ngSubmit)="onSubmit()">

        <mat-form-field appearance="fill">
            <mat-label>Название вида работ</mat-label>
            <input matInput formControlName="name" />
        </mat-form-field>

        <app-common-dropdown [label]="'Проект'" [service]="projectSelectorService" [formCtrl]="workForm.controls.projectId"/>

        <div class="flex justify-between">
            <button mat-stroked-button class="w-40" color="basic" type="button" [disabled]="!work.data.id" (click)="deleteWork(work.data.id)">Удалить</button>
            <button mat-flat-button class="w-40" color="primary" type="submit" [disabled]="!workForm.valid">Сохранить</button>
        </div>
    </form>
</mat-dialog-content>

